import { parseAsInteger, useQueryState } from "nuqs";

export const useSlotDialogParam = () => {
  return useQueryState("slotId", parseAsInteger);
};
